export default "__VITE_ASSET__CDMsp0yF__"